module.exports = __webpack_public_path__ + "img/title-bg.3bba1800.png";